var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('v-img',_vm._b({attrs:{"src":_vm.src},on:{"error":function($event){_vm.src = _vm.defaultImageUrl},"load":function($event){return _vm.$emit('imageLoaded', $event)}}},'v-img',_vm.$attrs,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }